export interface CookieBanner extends Element {
  createPrivacyShields: Function;
  removePrivacyShields: Function;
  getConsents: Function;
  changeLanguage: Function;
}

export interface CookieBannerEntry {
  name: string;
  enabled: boolean;
}

export function initCookieLanguage () {
  document.addEventListener('usercentrics-consents-loaded', () => {
    const banner = document.querySelector('cmm-cookie-banner') as CookieBanner;
    banner?.changeLanguage(document.documentElement.lang);
  }, false);
}
